import { render, staticRenderFns } from "./ManageOrg.vue?vue&type=template&id=5492824a&scoped=true"
import script from "./ManageOrg.vue?vue&type=script&lang=js"
export * from "./ManageOrg.vue?vue&type=script&lang=js"
import style0 from "./ManageOrg.vue?vue&type=style&index=0&id=5492824a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5492824a",
  null
  
)

export default component.exports